
// Peekaboo Shades - Make theme functional
console.log('🎨 Peekaboo Shades - Initializing functionality...');

document.addEventListener('DOMContentLoaded', function() {
  // Products for dropdown
  const products = [
    { name: 'Zebra Shades', url: '/products/zebra-shades' },
    { name: 'Roller Shades', url: '/products/roller-shades' },
    { name: 'Roman Shades', url: '/products/roman-shades' },
    { name: 'Honeycomb Shades', url: '/products/honeycomb-shades' }
  ];

  // Find navigation dropdown
  const selectors = [
    'nav a[href*="BLINDS"]',
    'nav a[href*="blinds"]',
    '.main-nav li:first-child',
    'nav li:first-child'
  ];

  let navItem = null;
  for (const selector of selectors) {
    navItem = document.querySelector(selector);
    if (navItem) {
      navItem = navItem.closest('li') || navItem.parentElement;
      break;
    }
  }

  if (navItem) {
    // Add dropdown class
    navItem.classList.add('nav-dropdown');

    // Create dropdown menu
    let menu = navItem.querySelector('.dropdown-menu');
    if (!menu) {
      menu = document.createElement('div');
      menu.className = 'dropdown-menu';
      navItem.appendChild(menu);
    }

    // Add product links
    menu.innerHTML = products.map(p =>
      `<a href="${p.url}">${p.name}</a>`
    ).join('');

    console.log('✅ Product dropdown created');
  }

  // Make all buttons work
  const buttons = document.querySelectorAll('button, .btn, a.button, [role="button"]');

  buttons.forEach(button => {
    const text = button.textContent.trim().toLowerCase();

    if (text.includes('shop all') || text.includes('shop now')) {
      button.style.cursor = 'pointer';
      button.onclick = function(e) {
        e.preventDefault();
        window.location.href = '/collections/all';
      };
    } else if (text.includes('build your own')) {
      button.style.cursor = 'pointer';
      button.onclick = function(e) {
        e.preventDefault();
        window.location.href = '/pages/build-your-own';
      };
    } else if (text.includes('shade simulator')) {
      button.style.cursor = 'pointer';
      button.onclick = function(e) {
        e.preventDefault();
        window.location.href = '/pages/shade-simulator';
      };
    } else if (text.includes('request') && text.includes('quote')) {
      button.style.cursor = 'pointer';
      button.onclick = function(e) {
        e.preventDefault();
        window.location.href = '/pages/request-quote';
      };
    }
  });

  console.log('✅ All buttons initialized');
});
